const routes = [
    {
        path: "/role/filters",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            isAdmin: true,
        }
    }
];

export default routes;
